import {
  TransactionTemplateFormatEnum,
  TransactionTemplateImportTypeEnum,
} from '@commenda/api/sales-tax/types';
import Papa from 'papaparse';

const SALES_TAX_TRANSACTIONS_COLUMN_LIST_FOR_INVOICE_IMPORT_COLUMN_MAPPING: {
  name: string;
  label: string;
  required: boolean;
  advanced: boolean;
}[] = [
  {
    name: 'Transaction Type',
    label: 'Transaction Type',
    required: false,
    advanced: true,
  },
  {
    name: 'Transaction Date (YYYY-MM-DD)',
    label: 'Transaction Date (YYYY-MM-DD)',
    required: true,
    advanced: false,
  },

  {
    name: 'Transaction Status',
    label: 'Transaction Status',
    required: false,
    advanced: false,
  },
  // {
  //   name: 'Tax Date Override (YYYY-MM-DD)',
  //   label: 'Tax Date Override',
  //   required: false,
  //   advanced: false,
  // },
  {
    name: 'Invoice Number',
    label: 'Invoice Number',
    required: false,
    advanced: false,
  },
  {
    name: 'Price Per Unit',
    label: 'Amount',
    required: true,
    advanced: false,
  },
  {
    name: 'Discount',
    label: 'Discount',
    required: false,
    advanced: false,
  },
  {
    name: 'Item Tax',
    label: 'Item Tax',
    required: false,
    advanced: false,
  },
  {
    name: 'Ship From Address Line 1',
    label: 'Ship-From Address Line 1',
    required: false,
    advanced: true,
  },
  {
    name: 'Ship From Address Line 2',
    label: 'Ship-From Address Line 2',
    required: false,
    advanced: true,
  },
  {
    name: 'Ship From Address Line 3',
    label: 'Ship-From Address Line 3',
    required: false,
    advanced: true,
  },
  {
    name: 'Ship From City',
    label: 'Ship-From City',
    required: false,
    advanced: true,
  },
  {
    name: 'Ship From State Code',
    label: 'Ship-From State Code',
    required: false,
    advanced: true,
  },
  {
    name: 'Ship From Postal Code',
    label: 'Ship-From Postal Code',
    required: false,
    advanced: true,
  },
  {
    name: 'Ship From Country Code',
    label: 'Ship-from Country Code',
    required: false,
    advanced: true,
  },
  {
    name: 'Ship To Address Line 1',
    label: 'Ship-To Address Line 1',
    required: false,
    advanced: false,
  },
  {
    name: 'Ship To Address Line 2',
    label: 'Ship-To Address Line 2',
    required: false,
    advanced: false,
  },
  {
    name: 'Ship To City',
    label: 'Ship-To City',
    required: false,
    advanced: false,
  },
  {
    name: 'Ship To State Code',
    label: 'Ship-To State Code',
    required: true,
    advanced: false,
  },
  {
    name: 'Ship To Postal Code',
    label: 'Ship-To Postal Code',
    required: true,
    advanced: false,
  },
  {
    name: 'Ship To Country Code',
    label: 'Ship To Country Code',
    required: false,
    advanced: false,
  },
  // {
  //   name: 'Commenda Product ID',
  //   label: 'Commenda Product ID',
  //   required: false,
  //   advanced: true,
  // },
  {
    name: 'Product SKU',
    label: 'Product SKU',
    required: false,
    advanced: true,
  },
  {
    name: 'Product Taxability Code',
    label: 'Product Taxability Code',
    required: false,
    advanced: true,
  },
  // {
  //   name: 'Commenda Customer ID',
  //   label: 'Commenda Customer ID',
  //   required: false,
  //   advanced: true,
  // },
  {
    name: 'Exemption Reason',
    label: 'Exemption Reason',
    required: false,
    advanced: true,
  },
  // {
  //   name: 'Exemption Certificate ID',
  //   label: 'Exemption Certificate ID',
  //   required: false,
  //   advanced: true,
  // },
  {
    name: 'Marketplace',
    label: 'Marketplace',
    required: false,
    advanced: true,
  },
  {
    name: 'Tax Remitter Type',
    label: 'Tax Remitter Type',
    required: false,
    advanced: true,
  },
  {
    name: 'Customer Business Identification Number',
    label: 'Customer Business Identification Number',
    required: false,
    advanced: true,
  },
  {
    name: 'Currency Code',
    label: 'Currency Code',
    required: false,
    advanced: false,
  },
];

const SALES_TAX_TRANSACTIONS_COLUMN_LIST_FOR_LINE_ITEM_IMPORT_COLUMN_MAPPING: {
  name: string;
  label: string;
  required: boolean;
  advanced: boolean;
}[] = [
  {
    name: 'Transaction Type',
    label: 'Transaction Type',
    required: false,
    advanced: true,
  },
  {
    name: 'Transaction Date (YYYY-MM-DD)',
    label: 'Transaction Date (YYYY-MM-DD)',
    required: true,
    advanced: false,
  },
  // {
  //   name: 'Tax Date Override (YYYY-MM-DD)',
  //   label: 'Tax Date Override (YYYY-MM-DD)',
  //   required: false,
  //   advanced: false,
  // },
  {
    name: 'Invoice Number',
    label: 'Invoice Number',
    required: true,
    advanced: false,
  },
  {
    name: 'Line Number',
    label: 'Line Number',
    required: true,
    advanced: false,
  },
  {
    name: 'Price Per Unit',
    label: 'Price Per Unit',
    required: true,
    advanced: false,
  },
  {
    name: 'Quantity',
    label: 'Quantity',
    required: true,
    advanced: false,
  },
  {
    name: 'Discount',
    label: 'Item Discount',
    required: false,
    advanced: false,
  },
  {
    name: 'Item Tax',
    label: 'Item Tax',
    required: false,
    advanced: false,
  },
  {
    name: 'Ship From Address Line 1',
    label: 'Ship-From Address Line 1',
    required: false,
    advanced: true,
  },
  {
    name: 'Ship From Address Line 2',
    label: 'Ship-From Address Line 2',
    required: false,
    advanced: true,
  },
  {
    name: 'Ship From Address Line 3',
    label: 'Ship-From Address Line 3',
    required: false,
    advanced: true,
  },
  {
    name: 'Ship From City',
    label: 'Ship-From City',
    required: false,
    advanced: true,
  },
  {
    name: 'Ship From State Code',
    label: 'Ship-From State Code',
    required: false,
    advanced: true,
  },
  {
    name: 'Ship From Postal Code',
    label: 'Ship-From Postal Code',
    required: false,
    advanced: true,
  },
  {
    name: 'Ship From Country Code',
    label: 'Ship-from Country Code',
    required: false,
    advanced: true,
  },
  {
    name: 'Ship To Address Line 1',
    label: 'Ship-To Address Line 1',
    required: false,
    advanced: false,
  },
  {
    name: 'Ship To Address Line 2',
    label: 'Ship-To Address Line 2',
    required: false,
    advanced: false,
  },

  {
    name: 'Ship To City',
    label: 'Ship-To City',
    required: false,
    advanced: false,
  },
  {
    name: 'Ship To State Code',
    label: 'Ship-To State Code',
    required: true,
    advanced: false,
  },
  {
    name: 'Ship To Postal Code',
    label: 'Ship-To Postal Code',
    required: true,
    advanced: false,
  },
  {
    name: 'Ship To Country Code',
    label: 'Ship To Country Code',
    required: false,
    advanced: false,
  },
  // {
  //   name: 'Commenda Product ID',
  //   label: 'Commenda Product ID',
  //   required: false,
  //   advanced: true,
  // },
  {
    name: 'Product SKU',
    label: 'Product SKU',
    required: false,
    advanced: true,
  },
  {
    name: 'Product Taxability Code',
    label: 'Product Taxability Code',
    required: false,
    advanced: false,
  },
  // {
  //   name: 'Commenda Customer ID',
  //   label: 'Commenda Customer ID',
  //   required: false,
  //   advanced: true,
  // },
  {
    name: 'Exemption Reason',
    label: 'Exemption Reason',
    required: false,
    advanced: true,
  },
  // {
  //   name: 'Exemption Certificate ID',
  //   label: 'Exemption Certificate ID',
  //   required: false,
  //   advanced: true,
  // },
  {
    name: 'Marketplace',
    label: 'Marketplace',
    required: false,
    advanced: true,
  },
  {
    name: 'Tax Remitter Type',
    label: 'Tax Remitter Type',
    required: false,
    advanced: true,
  },
  {
    name: 'Customer Business Identification Number',
    label: 'Customer Business Identification Number',
    required: false,
    advanced: true,
  },
  {
    name: 'Currency Code',
    label: 'Currency Code',
    required: false,
    advanced: false,
  },
];

/**
 * Column configuration for Germany (DE) and United Kingdom (GB) corporations.
 * These countries have a simplified flow with no Invoice/Line Item or Basic/Advanced selection.
 * The frontend transforms the CSV before upload: Transaction Type, VAT Number, and Reverse Charge
 * columns are combined into a single "Metadata" column containing a JSON object.
 */
const DE_GB_TRANSACTIONS_COLUMN_LIST_FOR_IMPORT: {
  name: string;
  label: string;
  required: boolean;
  advanced: boolean;
}[] = [
  // Required columns
  {
    name: 'Transaction Date (YYYY-MM-DD)',
    label: 'Transaction Date',
    required: true,
    advanced: false,
  },
  {
    name: 'Transaction Type',
    label: 'Transaction Type',
    required: true,
    advanced: false,
  },
  {
    name: 'Price Per Unit',
    label: 'Amount',
    required: true,
    advanced: false,
  },
  {
    name: 'Item Tax',
    label: 'Tax collected',
    required: true,
    advanced: false,
  },
  {
    name: 'Ship To Country Code',
    label: 'Ship-to-country Code',
    required: true,
    advanced: false,
  },
  // Optional columns
  {
    name: 'Transaction Status',
    label: 'Transaction Status',
    required: false,
    advanced: false,
  },
  {
    name: 'Invoice Number',
    label: 'Invoice Number',
    required: false,
    advanced: false,
  },
  {
    name: 'VAT Number',
    label: 'VAT Number',
    required: false,
    advanced: false,
  },
  {
    name: 'Reverse Charge',
    label: 'Reverse Charge',
    required: false,
    advanced: false,
  },
  {
    name: 'Product SKU',
    label: 'Product SKU',
    required: false,
    advanced: false,
  },
  {
    name: 'Discount',
    label: 'Discount',
    required: false,
    advanced: false,
  },
  {
    name: 'Ship To Address Line 1',
    label: 'Ship-to Address Line 1',
    required: false,
    advanced: false,
  },
  {
    name: 'Ship To Address Line 2',
    label: 'Ship-to Address Line 2',
    required: false,
    advanced: false,
  },
  {
    name: 'Ship To City',
    label: 'Ship-to City',
    required: false,
    advanced: false,
  },
  {
    name: 'Ship To State Code',
    label: 'Ship-to State',
    required: false,
    advanced: false,
  },
  {
    name: 'Ship To Postal Code',
    label: 'Ship-to Postal Code',
    required: false,
    advanced: false,
  },
  {
    name: 'Ship From Address Line 1',
    label: 'Ship-from Address Line 1',
    required: false,
    advanced: false,
  },
  {
    name: 'Ship From Address Line 2',
    label: 'Ship-from Address Line 2',
    required: false,
    advanced: false,
  },
  {
    name: 'Ship From City',
    label: 'Ship-from City',
    required: false,
    advanced: false,
  },
  {
    name: 'Ship From State Code',
    label: 'Ship-from State',
    required: false,
    advanced: false,
  },
  {
    name: 'Ship From Postal Code',
    label: 'Ship-from Postal Code',
    required: false,
    advanced: false,
  },
  {
    name: 'Ship From Country Code',
    label: 'Ship-from Country Code',
    required: false,
    advanced: false,
  },
  {
    name: 'Product Taxability Code',
    label: 'Product Taxability Code',
    required: false,
    advanced: false,
  },
  {
    name: 'Exemption Reason',
    label: 'Exemption Reason',
    required: false,
    advanced: false,
  },
  {
    name: 'Marketplace',
    label: 'Marketplace',
    required: false,
    advanced: false,
  },
  {
    name: 'Tax Remitter Type',
    label: 'Tax Remitter Type',
    required: false,
    advanced: false,
  },
  {
    name: 'Customer Business Identification Number',
    label: 'Customer Business Identification Number',
    required: false,
    advanced: false,
  },
  {
    name: 'Currency Code',
    label: 'Currency Code',
    required: false,
    advanced: false,
  },
];

const INDIA_ADD_TRANSACTIONS_COLUMN_LIST_FOR_IMPORT_COLUMN_MAPPING: {
  name: string;
  label: string;
  required: boolean;
  advanced: boolean;
}[] = [
  {
    name: 'GSTIN',
    label: 'GSTIN',
    required: true,
    advanced: false,
  },
  {
    name: 'Transaction Date (YYYY-MM-DD)',
    label: 'Transaction Date (YYYY-MM-DD)',
    required: true,
    advanced: false,
  },
  {
    name: 'Taxable Value',
    label: 'Taxable Value',
    required: true,
    advanced: false,
  },
  {
    name: 'Tax Rate',
    label: 'Tax Rate',
    required: true,
    advanced: false,
  },
  {
    name: 'Tax Value',
    label: 'Tax Value',
    required: true,
    advanced: false,
  },
  {
    name: 'Invoice Value',
    label: 'Invoice Value',
    required: true,
    advanced: false,
  },
  {
    name: 'Address',
    label: 'Address',
    required: true,
    advanced: false,
  },
];

/** ISO 3166-1 country codes for DE and GB */
export const DE_GB_COUNTRY_CODES = ['DE', 'GB'] as const;

export const getSalesTaxTransactionsColumnListForImport = (
  importType: TransactionTemplateImportTypeEnum,
  isEUVATCustomer: boolean,
  incorporationCountry?: string
) => {
  // Germany and UK have a simplified column set
  if (isEUVATCustomer) {
    return DE_GB_TRANSACTIONS_COLUMN_LIST_FOR_IMPORT;
  }

  // Default: US and other countries use invoice/line item based columns
  return importType === TransactionTemplateImportTypeEnum.INVOICES
    ? SALES_TAX_TRANSACTIONS_COLUMN_LIST_FOR_INVOICE_IMPORT_COLUMN_MAPPING
    : SALES_TAX_TRANSACTIONS_COLUMN_LIST_FOR_LINE_ITEM_IMPORT_COLUMN_MAPPING;
};

const SALES_TAX_TRANSACTIONS_COLUMN_KEY_TO_NAME_MAPPING_LIST_FOR_DATA_EXPORT = [
  {
    name: 'Transaction ID',
    key: 'id',
  },
  {
    name: 'Transaction Date',
    key: 'date',
  },
  {
    name: 'Transaction Type',
    key: 'type',
  },
  {
    name: 'Status',
    key: 'status',
  },
  {
    name: 'Ship-to State',
    key: 'destinationState',
  },
  {
    name: 'Amount',
    key: 'amount',
  },
  {
    name: 'Tax collected',
    key: 'taxCollected',
  },
  {
    name: 'Total',
    key: 'total',
  },
  {
    name: 'Source',
    key: 'sourcePlatform',
  },
];

export const SALES_TAX_TRANSACTIONS_COLUMN_KEY_TO_NAME_MAPPING_FOR_DATA_EXPORT =
  SALES_TAX_TRANSACTIONS_COLUMN_KEY_TO_NAME_MAPPING_LIST_FOR_DATA_EXPORT.reduce(
    (acc, header) => ({
      ...acc,
      [header.key]: header.name,
    }),
    {} as Record<string, string>
  );

export const TRANSACTION_IMPORT_TYPES: {
  title: string;
  description: string;
  id: TransactionTemplateImportTypeEnum;
}[] = [
  {
    title: 'Invoices',
    description:
      'Import complete invoice records with customer information and totals.',
    id: TransactionTemplateImportTypeEnum.INVOICES,
  },
  {
    title: 'Line Items',
    description:
      'Import individual transaction line items with detailed product information.',
    id: TransactionTemplateImportTypeEnum.LINE_ITEMS,
  },
];

export const TRANSACTION_TEMPLATE_FORMATS: {
  title: string;
  description: string;
  id: TransactionTemplateFormatEnum;
}[] = [
  {
    title: 'Basic',
    description: 'Essential invoice information only.',
    id: TransactionTemplateFormatEnum.BASIC,
  },
  {
    title: 'Advanced',
    description: 'Includes detailed metadata and custom fields.',
    id: TransactionTemplateFormatEnum.ADVANCED,
  },
];

/**
 * Metadata column names that will be combined into a single JSON column for DE/GB.
 * These columns will be removed from the CSV and their values combined into a "Metadata" column.
 */
const DE_GB_METADATA_COLUMNS = {
  TRANSACTION_TYPE: 'Transaction Type',
  VAT_NUMBER: 'VAT Number',
  REVERSE_CHARGE: 'Reverse Charge',
} as const;

/**
 * Transforms a CSV file for DE/GB countries by combining metadata fields into a single JSON column.
 *
 * Takes the values from Transaction Type, VAT Number, and Reverse Charge columns,
 * creates a JSON object, adds it as a "Metadata" column, and removes the original columns.
 *
 * @param file - The original CSV file uploaded by the user
 * @param columnMapping - The column mapping from user's CSV columns to template columns
 * @returns A new File object with the transformed CSV content
 */
export const transformCsvForDeGb = async (
  file: File,
  columnMapping: { fromColumn: string; toColumn: string }[]
): Promise<File> => {
  return new Promise((resolve, reject) => {
    Papa.parse<Record<string, string>>(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        try {
          const { data, meta } = results;

          if (!meta.fields) {
            reject(new Error('Failed to parse CSV headers'));
            return;
          }

          // Get the original column names
          const originalFields = meta.fields;

          // Find original column names from the mapping
          // The mapping tells us: fromColumn (user's CSV) -> toColumn (template name)
          const findOriginalColumn = (
            templateName: string
          ): string | undefined => {
            const mapping = columnMapping.find(
              (m) => m.toColumn === templateName
            );
            return mapping?.fromColumn;
          };

          const transactionTypeColumn = findOriginalColumn(
            DE_GB_METADATA_COLUMNS.TRANSACTION_TYPE
          );
          const vatNumberColumn = findOriginalColumn(
            DE_GB_METADATA_COLUMNS.VAT_NUMBER
          );
          const reverseChargeColumn = findOriginalColumn(
            DE_GB_METADATA_COLUMNS.REVERSE_CHARGE
          );

          // Check which metadata columns exist in the CSV (using original names)
          const hasTransactionType =
            transactionTypeColumn &&
            originalFields.includes(transactionTypeColumn);
          const hasVatNumber =
            vatNumberColumn && originalFields.includes(vatNumberColumn);
          const hasReverseCharge =
            reverseChargeColumn && originalFields.includes(reverseChargeColumn);

          // Create new fields array: remove VAT and Reverse Charge columns, keep Transaction Type, add Metadata column
          const newFields = originalFields.filter(
            (field) =>
              field !== vatNumberColumn && field !== reverseChargeColumn
          );
          newFields.push('Metadata');

          // Transform each row
          const transformedData = data.map((row) => {
            // Build metadata JSON object
            const metadata: {
              transactionType?: string;
              vatNumber?: string;
              reverseCharge?: string;
            } = {};

            if (
              hasTransactionType &&
              transactionTypeColumn &&
              row[transactionTypeColumn]
            ) {
              // Store original transaction type in metadata
              metadata.transactionType = row[transactionTypeColumn];
            }
            if (hasVatNumber && vatNumberColumn && row[vatNumberColumn]) {
              metadata.vatNumber = row[vatNumberColumn];
            }
            if (
              hasReverseCharge &&
              reverseChargeColumn &&
              row[reverseChargeColumn]
            ) {
              metadata.reverseCharge = row[reverseChargeColumn];
            }

            // Create new row without VAT/Reverse Charge columns, add Metadata JSON
            const newRow: Record<string, string> = {};
            for (const field of newFields) {
              if (field === 'Metadata') {
                newRow[field] = JSON.stringify(metadata);
              } else if (field === transactionTypeColumn) {
                newRow[field] = row[field] || '';
              } else {
                newRow[field] = row[field] || '';
              }
            }

            return newRow;
          });

          // Convert back to CSV
          const csvContent = Papa.unparse(transformedData, {
            columns: newFields,
          });

          // Create new File object
          const transformedFile = new File([csvContent], file.name, {
            type: 'text/csv',
          });

          resolve(transformedFile);
        } catch (error) {
          reject(
            error instanceof Error
              ? error
              : new Error('Failed to transform CSV')
          );
        }
      },
      error: (error) => {
        reject(new Error(`Failed to parse CSV: ${error.message}`));
      },
    });
  });
};

export const TRANSACTION_TEMPLATE = {
  'invoices-basic': {
    text: 'Invoice Template',
    link: 'https://public-commenda-bucket.s3.ap-south-1.amazonaws.com/Basic+Invoice+Template.xlsx',
  },
  'invoices-advanced': {
    text: 'Invoice Template',
    link: 'https://public-commenda-bucket.s3.ap-south-1.amazonaws.com/Advanced+Invoice+Template.xlsx',
  },
  'line-items-basic': {
    text: 'Line Items Template',
    link: 'https://public-commenda-bucket.s3.ap-south-1.amazonaws.com/Basic+Line+Import+Template.xlsx',
  },
  'line-items-advanced': {
    text: 'Line Items Template',
    link: 'https://public-commenda-bucket.s3.ap-south-1.amazonaws.com/Advanced+Line+Items+Template.xlsx',
  },
};
